import React from "react";
// import { Worker, Viewer } from '@react-pdf-viewer/core';
import "@react-pdf-viewer/core/lib/styles/index.css";

const PopupDatosPersonales = ({ filePath, onClose }) => {

  const styles = {
    modal: {
      display: "block",
      backgroundColor: "rgba(0, 0, 0, 0.5)",
    },
    modalDialog: {
      maxWidth: "700px",
    },
    closeButton: {
      position: "absolute",
      top: "10px",
      right: "10px",
      background: "transparent",
      border: "none",
      fontSize: "24px",
      cursor: "pointer",
    },
    modalContent: {
      padding: "20px",
    },
    scrollableContent: {
      height: "600px",
      overflowY: "auto",
    },
    heading1: {
      textAlign: "center",
      fontSize: "1.5rem",
      marginBottom: "20px",
    },
    heading2: {
      marginTop: "20px",
      fontSize: "1.25rem",
    },
    table: {
      width: "100%",
      borderCollapse: "collapse",
      margin: "20px 0",
    },
    th: {
      border: "1px solid #ddd",
      padding: "10px",
      backgroundColor: "#f4f4f4",
      textAlign: "left",
    },
    td: {
      border: "1px solid #ddd",
      padding: "10px",
      textAlign: "left",
    },
    ul: {
      marginTop: "10px",
      paddingLeft: "20px",
    },
    li: {
      marginBottom: "10px",
    },
    signatureSection: {
      marginTop: "40px",
    },
    signatureLine: {
      marginTop: "20px",
      borderTop: "1px solid #000",
      width: "50%",
    },
  };

  return (
    <div>
      <div
        className="modal fade show"
        style={styles.modal}
        tabIndex="-1"
        role="dialog"
      >
        <div
          className="modal-dialog modal-dialog-centered"
          role="document"
          style={styles.modalDialog}
        >
          <div className="modal-content modal-succes">
            <div className="modal-body body-cita-confirmada" style={styles.modalContent}>
              <button onClick={onClose} style={styles.closeButton}>
                &times;
              </button>
             
              <h1 style={styles.heading}>
              AUTORIZACIÓN PARA EL TRATAMIENTO DE DATOS PERSONALES
            </h1>
            <p style={styles.paragraph}>
              Al aceptar las condiciones que siguen mediante clic, touch, firma física o electrónica u otro mecanismo
              análogo, otorgo mi autorización a <span style={styles.bold}>LUXOTTICA OF CHILE S.A.</span> (en adelante Luxottica),
              domiciliado en la Avenida Santa Clara 249, Ciudad Empresarial, comuna de Huechuraba, ciudad de Santiago,
              Chile, para que registre mis datos personales generales (identificación y contacto) y sensibles (medida, en caso
              aplique), que se recopilan a través de su sitio web, aplicaciones móviles, redes sociales, formularios digitales
              y/o físicos, correo electrónico, así como cualquier medio electrónico o digital online u offline equivalente; por
              el tiempo que sea necesario para la finalidad que se recopilaron, para su procesamiento, fines estadísticos o más
              tiempo si se exige en virtud de un contrato o legislación aplicable. Lo anterior, sin perjuicio de la posibilidad
              que tengo de revocar mi consentimiento.
            </p>
            <p style={styles.paragraph}>
              El tratamiento de datos será con la finalidad de que Luxottica, por medio de sus distintas marcas asociadas,
              pueda contactarme y enviarme información sobre los productos y/u otros servicios complementarios que pudieran ser
              de mi interés; comunicarme sobre promociones exclusivas y/o personalizadas, beneficios, concursos, ofertas; hacer
              seguimiento a mis cotizaciones; y, en general, realizar publicidad y prospección comercial. Asimismo, las marcas
              podrán contactarme para realizar encuestas de satisfacción, análisis de consumo, preferencias y tendencias de
              mercado.
            </p>
            <p style={styles.paragraph}>
              Para cumplir con estas finalidades, Luxottica, actuando como responsable de los datos personales, podrá tratar mis
              datos personales directamente o podrá contratar a terceros encargados y compartirlos con otras empresas del grupo
              al que pertenece. Estas empresas podrán encontrarse dentro o fuera del Chile, con lo cual estoy conforme y acepto
              expresamente.
            </p>
            <p style={styles.paragraph}>
              En cualquier caso, Luxottica garantiza la confidencialidad y seguridad de la información que comparte. En caso
              existan nuevos encargados o terceros que pudieran tener acceso o tratar mis datos, Luxottica me los podrá comunicar
              vía correo electrónico.
            </p>
            <p style={styles.paragraph}>
              He sido informad@ que esta autorización es facultativa pero que, si no la otorgo, ninguna de las finalidades arriba
              indicadas podrá realizarse. Asimismo, que podré ejercer los derechos previstos en la Ley N° 19.628, dirigiendo una
              solicitud al correo electrónico{" "}
              <a href="mailto:derecho.arco@cl.luxottica.com">derecho.arco@cl.luxottica.com</a> o enviando una comunicación
              escrita con el asunto “Derechos Datos Personales” a la dirección Avenida Santa Clara 249, Ciudad Empresarial,
              comuna de Huechuraba, ciudad de Santiago, Chile. Soy consciente de que podré solicitar la suspensión del envío de
              las comunicaciones publicitarias o comerciales de conformidad al artículo 28 B de la Ley N°19.496. En el eventual
              caso que considere que mis derechos no han sido atendidos, he sido informado de que puedo presentar una reclamación
              ante los Tribunales ordinarios de Justicia.
            </p>
            <p style={styles.paragraph}>
              Finalmente declaro que la información y datos personales que he dispuesto para el tratamiento por parte de
              Luxottica, los he suministrado de forma voluntaria, están actualizados y son verídicos.
            </p>
            <p style={styles.paragraph}>
              Sin perjuicio de que en futuro puedan variar, se deja constancia que son marcas de Luxottica: Ópticas GMO,
              Sunglass Hut, Econópticas y Tiendas RayBan.
            </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PopupDatosPersonales;
